/**
 * StatusRibbon — diagonal corner banner across the top-left of a property image
 * for in-progress sale statuses (Sale Agreed / Under Offer). Localised via the
 * top-level rsStatus strings; renders on its own layer with pointer-events:none
 * so it never affects the other image overlays or carousel interaction.
 *
 * Props:
 *   - statusBanner {('SaleAgreed'|'UnderOffer'|null)} — from the offer view-model
 *   - l            {Object} — the full localization instance (useLocalization)
 *   - unavailable  {boolean} — a selected unit that can no longer be offered;
 *                              takes precedence over the sale-status banner
 */
import React from 'react';

export default function StatusRibbon({ statusBanner, l, unavailable }) {
    if (unavailable) {
        const label = (l && l.resalesLanding && l.resalesLanding.unitUnavailable) || 'No longer available';
        return (
            <div className="rs-ribbon rs-ribbon--unavailable" aria-hidden="true">
                <span className="rs-ribbon__band">{label}</span>
            </div>
        );
    }
    if (!statusBanner) return null;
    const label = (l && l.rsStatus && l.rsStatus[statusBanner])
        || (statusBanner === 'SaleAgreed' ? 'Sale Agreed' : 'Under Offer');
    return (
        <div className={`rs-ribbon rs-ribbon--${statusBanner === 'SaleAgreed' ? 'agreed' : 'offer'}`} aria-hidden="true">
            <span className="rs-ribbon__band">{label}</span>
        </div>
    );
}
